const Separator = () => (
  <div className="separator-block">
    <div className="ln-o-grid ml-spacer">
      <div className="separator-line" />
    </div>
  </div>
)

export default Separator
